import { baseApi } from "./baseApi";

export interface PaymentProvider {
  id: string;
  name: string;
  description: string;
}

export interface InitializePaymentRequest {
  orderId: string;
  provider: "paystack" | "flutterwave";
}

export interface InitializePaymentResponse {
  success: boolean;
  data: {
    redirectUrl: string;
    reference: string;
    provider: string;
  };
  message?: string;
}

export interface VerifyPaymentRequest {
  reference?: string;
  transaction_id?: string;
  tx_ref?: string;
}

/**
 * Payment API slice
 * All payment logic is handled server-side
 */
export const paymentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get available payment providers
    getPaymentProviders: builder.query<
      { success: boolean; data: { providers: PaymentProvider[] } },
      void
    >({
      query: () => "/payments/providers",
    }),

    // Initialize payment - returns redirect URL
    initializePayment: builder.mutation<
      InitializePaymentResponse,
      InitializePaymentRequest
    >({
      query: (data) => ({
        url: "/payments/initialize",
        method: "POST",
        body: data,
        credentials: "include",
      }),
    }),

    // Verify Paystack payment
    verifyPaystackPayment: builder.mutation<
      { success: boolean; data: any; message?: string },
      VerifyPaymentRequest
    >({
      query: (data) => ({
        url: "/payments/verify/paystack",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      invalidatesTags: ["Order"],
    }),

    // Verify Flutterwave payment
    verifyFlutterwavePayment: builder.mutation<
      { success: boolean; data: any; message?: string },
      VerifyPaymentRequest
    >({
      query: (data) => ({
        url: "/payments/verify/flutterwave",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      invalidatesTags: ["Order"],
    }),
  }),
});

export const {
  useGetPaymentProvidersQuery,
  useInitializePaymentMutation,
  useVerifyPaystackPaymentMutation,
  useVerifyFlutterwavePaymentMutation,
} = paymentApi;
